import { type MaybeRefOrGetter, toValue } from 'vue'
import { queryOptions } from '@tanstack/vue-query'
import { fetchActivityLog } from '@/features/invoices/api/fetchActivityLog'
import { fetchInvoiceTemplate } from '@/features/invoices/api/fetchInvoiceTemplate'
import { fetchInvoice } from '@/features/invoices/api/fetchInvoice'
import { creditNoteQueryKeys } from '@/features/invoices/query-keys'
import { getAllocatableCreditNotes } from '@/features/invoices/api/get-allocatable-credit-notes'
// import { getCreditNotes } from '@/features/invoices/api/get-credit-notes'

export const fetchActivityLogQueryOptions = (invoiceId: MaybeRefOrGetter<number>) => queryOptions({
  queryKey: ['invoices:activity', invoiceId],
  queryFn: () => fetchActivityLog(toValue(invoiceId))
})

export const fetchInvoiceTemplateQueryOptions = (assetCode: MaybeRefOrGetter<string>) => queryOptions({
  queryKey: ['invoices:config', assetCode],
  queryFn: () => fetchInvoiceTemplate(toValue(assetCode)),
})

export const fetchInvoiceQueryOptions = (invoiceId: MaybeRefOrGetter<number>) => queryOptions({
  queryKey: ['invoices', invoiceId],
  queryFn: () => fetchInvoice(toValue(invoiceId))
})

export const creditNoteQueries = {
  allocatable: (invoiceId: MaybeRefOrGetter<number>) => queryOptions({
    queryKey: creditNoteQueryKeys.allocatable(invoiceId),
    queryFn: () => getAllocatableCreditNotes(toValue(invoiceId)),
  }),

  // bulkDetails: (creditNoteIds: MaybeRefOrGetter<number[]>) => queryOptions({
  //   queryKey: creditNoteQueryKeys.details(creditNoteIds),
  //   enabled: () => toValue(creditNoteIds).length > 0,
  //   queryFn: () => getCreditNotes(toValue(creditNoteIds))
  // })
} as const
